import "regenerator-runtime/runtime.js";

import { registerApplication, start } from "single-spa";
import { constructApplications, constructLayoutEngine, constructRoutes } from "single-spa-layout";
import API, { simpleApi } from "./api/api";
import * as application404 from "./application404";
import Configurator from "./configurator";
import axios from "axios";

// Fonts
import "@fontsource/material-icons";
import "@fontsource/roboto/latin.css";
import "@fontsource/roboto/cyrillic.css";
import "@mdi/font/css/materialdesignicons.css";

// Our styles
import "./styles/global.scss";
import "./styles/overwrite.scss";
import { wrapConsole } from "./wrapConsole";

const bootstrapApplication = async() => {
  const layout = (await axios.get("/microfrontend-layout.html")).data;
  const routes = constructRoutes(layout, {
    loaders: {},
    props: {},
  });
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  applications.forEach(registerApplication);

  registerApplication({
    name: "@dhl/page-404",
    app: application404,
    activeWhen: "/404",
  });

  layoutEngine.activate();
  start({ urlRerouteOnly: true });
};

wrapConsole();
const configurator = new Configurator(simpleApi);

API.authClient.authenticate()
  .then(() => configurator.getConfig())
  .then(() => {
    (window as any).DHL_API = API; // eslint-disable-line
    (window as any).DHL_CONFIG = configurator.config; // eslint-disable-line

    bootstrapApplication();
  });
